import React from 'react';

const UserManagementTab: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg p-6">
    <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">User Management</h2>
    <p className="text-gray-700 dark:text-gray-300">Content for User Management goes here.</p>
  </div>
);

export default UserManagementTab;
